import cloneDeepWith = require("lodash/cloneDeepWith");
import {isArrayLike, ObservableMap} from "mobx";


export function stringify(data): string {
  return JSON.stringify(data, function(key, value){
    return (key.startsWith('$')) ? undefined : value;
  });
}


function addReference(root, object, level) {
  console.debug('addReference object = %o, level = %s', object, level);

  for (let i in object) {
    if (object.hasOwnProperty(i)) {
      let subObject = object[i];

      if (subObject !== null && typeof(subObject) == "object") {
        if (isArrayLike(subObject)) {
          for (let item of subObject) { // item has type of {}
            const itemAny: any = item;
            addReference(root, itemAny, level + 1);
            itemAny.$parentArray = subObject;
            itemAny.$parentObject = object;
            itemAny.$rootObject = root;
          }
        } else {
          addReference(root, subObject, level + 1);
          subObject.$parentObject = object;
          subObject.$rootObject = root;
        }
      }
    }
  }
}



export function addReferences(dataObject) {
  addReference(dataObject, dataObject, 0);
  dataObject.$rootObject = dataObject;
  return dataObject;
}

export function isLovValueObjectOnly(object) {
  let keyCount = Object.keys(object).length;
  return  object.hasOwnProperty("value") && object.hasOwnProperty("label") && (keyCount === 2 || (keyCount === 3 && object.hasOwnProperty("params")) );
}

/**
 * Zavola funkci fn(object, level) na dodany object a potom projde vsechny properties objectu a pokud je to object zavola rekurzivne walk(), totez pro kazdy prvek pokud je to array
 * @param object
 * @param level
 * @param fn
 */
export function walk(object: any, fn: (object: any, level: number) => void) {
  const visited: Set<any> = new Set<any>();
  walkInner(object, 0, 'ROOT', fn, visited);
}

function walkInner(object: any, level: number, keyName: string, fn: (object: any, level: number) => void, visited: Set<any>) {
  console.debug('%s. walk %s = %O', level, keyName, object);

  if (visited.has(object)) return;
  visited.add(object);

  fn(object, level);

  for (let key in object) {
    if (object.hasOwnProperty(key) && !key.startsWith('$') ) {
      let subObject = object[key];

      if (subObject !== null && typeof(subObject) == "object") {

        if (isArrayLike(subObject)) {
          for (let i = 0, len = subObject.length; i < len; i++) {
            let subObjectElement = subObject[i];
            if (subObjectElement) walkInner(subObjectElement, level + 1, key + '[' + i + ']', fn, visited);

          }
        } else if (subObject instanceof ObservableMap) {
          let omapValues: any[] = (subObject as ObservableMap<any>).values();
          for (let i = 0, len = omapValues.length; i < len; i++) {
            let omapValue = omapValues[i];
            if (omapValue) walkInner(omapValue, level + 1, key + '[' + i + ']', fn, visited);
          }
        } else {
          // vyloucime lovValues objekty
          if (subObject && !isLovValueObjectOnly(subObject)) {
            walkInner(subObject, level + 1, key, fn, visited);
          }
        }

      }
    }
  }
}

/**
 * Zavola funkci fn(object) na dodany object (pokud object neni null), ale pokud je dodany objekt array zavola funkci pro kazdy prvek pole
 * @param object
 * @param fn
 */
export function callOnObjectOrArray(object, fn) {
  if (object) {
    if (isArrayLike(object)) {
      for (let item of object) {
        fn(item);
      }
    } else {
      fn(object);
    }
  }
}

/**
 * zavola lodash cloneDeep, ale pomoci customizeru neklonuje properties zacinajici na $
 * @param object
 * @returns {*}
 */
export function cloneDeep<TResult>(object: any) : TResult {
  return cloneDeepWith(object, function(value: any, key: string) {
    if (key && key.startsWith && key.startsWith('$')) {
      return value;
    }
  });
}


export function getDescendantProp(objectLiteral: object, dottedKey: string) : string {

  if (objectLiteral[dottedKey]) {
    return objectLiteral[dottedKey];
  }

  const msg = dottedKey.split(".").reduce(function (a, b) {
    return (a != undefined) ? a[b] : a;
  }, objectLiteral);

  return msg;
}

/**
 * Returns value V of property with key _key_ from object _object_  <br>
 * If property does not exists it is created with function fn: (k: string) => V
 * @param object
 * @param key
 * @param fn
 */
export function createIfAbsent<V>(object, key: string, fn: (k: string) => V) {
  let value = object[key];
  if (value === undefined) {
    value = fn(key);
    object[key] = value;
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/core/common/utils/jsonUtils.ts